
const getData = state => state.data

export {
  getData
}